<script setup lang="ts">
import { da } from '@nuxt/ui/locale'

import { useTenant } from './composables/useTenants'

useTenant()

useHead({
  meta: [{ name: 'viewport', content: 'width=device-width, initial-scale=1' }],
  htmlAttrs: {
    lang: 'da',
  },
})
useSeoMeta({
  title: 'Fibertex kantine',
  description: 'App til bestilling af aftensmad, takeaway og mødeforplejning fra Fibertex Kantine',
})
</script>

<template>
  <UApp :locale="da" :toaster="{ position: 'bottom-center', duration: 10000 }">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
